import React from "react";
import NewsType from "../../NewsType";
import {ItemTitleMedium} from "../../../utils/titles";
import TripletItem from "../../../utils/TripletItem";
import Title from "../../Title";
import TwoThirdsMain from "../../TwoThirdsMain";
import {PUBLI_CLASS, PUBLI_REPORTS} from "../../../utils/constants";
import AuthorImage, {AuthorImageGrid} from "../../Images/AuthorImage";

export default function NewsImageDualComboText({ data }) {
  return (
    <>
      <TwoThirdsMain node={data[0]} />
      <TripletItem className={data[1].shn_type === PUBLI_REPORTS ? PUBLI_CLASS : null}>
        <AuthorImage  showImage={data[1].showAuthor} author={data[1].author} />
        <AuthorImageGrid>
          <NewsType catchLine={data[1]?.catchLine} newsType={data[1].shn_type} flag={data[1].flag} />
          <ItemTitleMedium>
            <Title title={data[1].title} link={data[1].link} paywall={data[1].paywall} />
          </ItemTitleMedium>
        </AuthorImageGrid>
      </TripletItem>
    </>
  )
}
